import React, { useEffect, useState } from "react";
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    Button, TextField, MenuItem, Select, FormControl,
    InputLabel, RadioGroup, FormControlLabel, Radio,
    Box,
    Typography,
    Modal,
    Backdrop,
    Fade,
    IconButton
} from "@mui/material";

const CustomTabBar = ({ tabs = [], marginTop = "0px", marginBottom = "0px", marginLeft = "0px", marginRight = "0px", gap = " 10px", selectedTab = 0, textColor = "#ffffff",
    fontSize = "18px", nonSelectedFontSize = "13px", nonSelectedTextColor = "#ffffff90", onChange = () => { } }) => {

    const [currentIndex, setCurrentIndex] = useState(selectedTab)


    useEffect(() => {
        setCurrentIndex(selectedTab)
    }, [selectedTab])

    return (
        <Box sx={{
            display: "flex",
            flexDirection: "row",
            gap: gap,
            marginLeft,
            marginRight,
            marginTop,
            marginBottom,
            overflowX: "auto",
            alignItems: "center",

            // Firefox
            scrollbarWidth: "none",

            // Chrome / Safari / Edge
            "&::-webkit-scrollbar": {
                display: "none",
            },

            // Old Edge / IE
            msOverflowStyle: "none",
        }}>

            {
                tabs.map((item, index) => (
                    <Box
                        onClick={() => onChange(index)}
                        sx={{
                            cursor: "pointer",
                            marginTop: currentIndex == index ? "0px" : "2px",
                            flexDirection: "row",
                            alignItems: "center",
                            display: "inline-flex",   // 👈 important
                            width: "max-content",     // 👈 shrink to text
                            justifyContent: "center",
                        }}>
                        <Typography
                            color={currentIndex == index ? textColor : nonSelectedTextColor}
                            fontFamily={currentIndex == index ? "poppins-mid" : "poppins-reg"}
                            style={{
                                whiteSpace: "nowrap",
                            }}
                            fontSize={currentIndex == index ? fontSize : nonSelectedFontSize}
                        >
                            {item}
                        </Typography>
                    </Box>
                ))
            }

        </Box>
    );
};

const styles = {
    popup: (width) => ({
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width,
        maxWidth: "90%",
        maxHeight: "85vh",
        bgcolor: "#0f0f0f",
        borderRadius: 3,
        boxShadow: 24,
        overflow: "hidden"
    }),
    header: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        px: 2,
        py: 1,
        borderBottom: "1px solid #aaaaaa20"
    },
    title: {
        fontSize: "14px",
        fontFamily: "poppins-reg"
    },
    body: {
        p: 2,
        overflowY: "auto"
    }
};


export default CustomTabBar;
